import { render, staticRenderFns } from "./ActModalTexto.vue?vue&type=template&id=ae0bbd06&scoped=true&"
import script from "./ActModalTexto.vue?vue&type=script&lang=js&"
export * from "./ActModalTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0bbd06",
  null
  
)

export default component.exports